import { useTheme } from "@mui/material/styles";
import { useAuth } from "../contexts/AuthContext";
import useNotification from "../hooks/useNotification";
import { useLoginDialog } from "../hooks/useLoginDialog";
import { useMediaQuery } from "@mui/material";
import { useState } from "react";
import ChangePasswordDialog from "./Admin/ChangePasswordDialog";
import { LoginDialog } from "./LoginDialog";
import MainHeader from "./MainHeader";

const Header = () => {
  const theme = useTheme();
  const { user, logout, isLoggedIn } = useAuth();
  const { showNotification } = useNotification();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const [changePasswordDialogOpen, setChangePasswordDialogOpen] =
    useState(false);
  const [userMenuAnchorEl, setUserMenuAnchorEl] = useState<null | HTMLElement>(
    null
  );

  const handleDownloadInvitationTemplate = () => {
    const templateUrl = process.env.REACT_APP_INVITATION_TEMPLATE_URL;
    if (templateUrl) {
      window.open(templateUrl, "_blank");
    } else {
      console.error("Invitation template URL is not defined");
      showNotification("Invitation template URL is not defined", "error");
    }
    handleUserMenuClose();
  };

  const handleUserMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setUserMenuAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setUserMenuAnchorEl(null);
  };

  const handleChangePassword = () => {
    handleUserMenuClose();
    setChangePasswordDialogOpen(true);
  };

  const handleLogout = () => {
    logout();
    handleUserMenuClose();
  };

  return (
    <header>
      <MainHeader
        isLoggedIn={isLoggedIn}
        user={user}
        onUserMenuClick={handleUserMenuClick}
        onUserMenuClose={handleUserMenuClose}
        userMenuAnchorEl={userMenuAnchorEl}
        onLogout={handleLogout}
        onChangePassword={handleChangePassword}
        onDownloadTemplate={handleDownloadInvitationTemplate}
      />
      <ChangePasswordDialog
        open={changePasswordDialogOpen}
        onClose={() => setChangePasswordDialogOpen(false)}
      />
    </header>
  );
};
export default Header;
